// Shared CSV helpers: field escaping, row→string assembly, and the browser
// download mechanic. Pure/DOM-only — no React, no domain types.

/** Escape a CSV field, quoting when it contains a comma, quote, or newline.
 *  Internal quotes are doubled per RFC 4180. */
export function escapeCsvValue(value: string | number): string {
    const s = String(value);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Build a CSV string from a header row and data rows (all values escaped). */
export function rowsToCsv(
    headers: ReadonlyArray<string | number>,
    rows: ReadonlyArray<ReadonlyArray<string | number>>,
): string {
    return [
        headers.map(escapeCsvValue).join(','),
        ...rows.map((r) => r.map(escapeCsvValue).join(',')),
    ].join('\n');
}

/** Trigger a browser download of `csv` as a UTF-8 .csv file. `filename` must
 *  include the `.csv` extension. The anchor is added to the DOM before clicking
 *  so the download works in Firefox, then removed. */
export function downloadCsvFile(filename: string, csv: string): void {
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
